<script setup lang="ts">
import { T } from '@tolgee/vue'
import { formatDuration } from '@/helpers/date'
import { usePuzzles } from '@/composables/game/puzzles'
import PuzzleIcon from '@/assets/images/puzzle-button-icon.png'
import PuzzleBg from '@/assets/images/puzzle-button-bg.png'

const { countdownForEventEnd, showPuzzle } = usePuzzles()

</script>

<template>
  <div
    v-if="showPuzzle"
    class="flex flex-col items-center justify-center"
  >
    <div class="bg-puzzles-container bg-puzzles-gradient relative flex items-center justify-center size-12 rounded-[15px] p-0.5">
      <img
        class="object-cover object-center"
        :src="PuzzleBg"
        alt="Puzzle Background"
      >
      <img
        class="w-[32px] absolute object-cover z-10 m-auto"
        :src="PuzzleIcon"
        alt="Puzzle Icon"
      >
    </div>
    <div class="z-[10] flex flex-col -mt-2 items-center">
      <div class="z-[1] whitespace-nowrap h-[18px] px-1.5 rounded-full bg-white flex items-center justify-center text-[10px] font-bold leading-[14px] -tracking-[0.3px] text-tropee-black">
        <T
          key-name="tap.jigsaw"
          default-value="Jigsaw"
        />
      </div>
      <div
        class="z-[2] -mt-1 whitespace-nowrap h-[18px] px-1.5 rounded-full bg-white flex items-center justify-center text-[10px] font-bold leading-[14px] -tracking-[0.3px] tabular-nums"
        :class="countdownForEventEnd < (3600 * 3) ? 'text-red-danger' : 'text-tropee-black'"
      >
        {{ formatDuration(countdownForEventEnd, undefined, countdownForEventEnd > (3600 * 72)) }}
      </div>
    </div>
  </div>
</template>

<style scoped>
.bg-puzzles-container {
  background: #FFF246;
}

.bg-puzzles-gradient {
  background: linear-gradient(180deg, #E73131 0%, #1C2A2B 100%)
}
</style>